export default __webpack_public_path__ + "static/media/Page23.43853893.txt";